export const PAGE_OPTIONS = [
  ["all", "Todas las páginas"], ["/", "Inicio"], ["/servicios", "Servicios"], ["/nosotros", "Nosotros"], ["/citas", "Citas"],
  ["/opiniones", "Opiniones"], ["/contacto", "Contacto"], ["/galeria", "Galería"], ["/testimonios", "Testimonios"],
];

export const EFFECT_LABELS = {
  ghosts: "Fantasmas", bats: "Murciélagos", fog: "Niebla", moon: "Luna llena", pumpkins: "Calabazas", webs: "Telarañas",
  sparks: "Destellos violetas", snow: "Nieve", lights: "Luces navideñas", santa: "Papá Noel en trineo", tree: "Árbol navideño",
  stars: "Estrellas y destellos", confetti: "Confeti", fireworks: "Fuegos artificiales", sparkles: "Destellos luminosos",
};

export const pageMatches = (pages, path) => pages.includes("all") || pages.includes(path.replace(/\/$/, "") || "/");

export const PagePicker = ({ value, onChange, id }) => (
  <div className="flex flex-wrap gap-2" data-testid={`${id}-pages`}>
    {PAGE_OPTIONS.map(([v, l]) => {
      const on = value.includes(v);
      const toggle = () => {
        if (v === "all") return onChange(["all"]);
        const rest = value.filter((p) => p !== "all" && p !== v);
        onChange(on ? (rest.length ? rest : ["all"]) : [...rest, v]);
      };
      return (
        <button type="button" key={v} onClick={toggle} data-testid={`${id}-page-${v === "/" ? "inicio" : v.replace("/", "")}`}
          className={`rounded-full border px-3 py-1 text-xs font-semibold ${on ? "border-gold bg-gold text-black" : "border-line text-mute"}`}>{l}</button>
      );
    })}
  </div>
);
